import { render } from "./AdminDependencyHealthView.vue?vue&type=template&id=d04327d0&scoped=true"
import script from "./AdminDependencyHealthView.vue?vue&type=script&lang=js"
export * from "./AdminDependencyHealthView.vue?vue&type=script&lang=js"

import "./AdminDependencyHealthView.vue?vue&type=style&index=0&id=d04327d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d04327d0"]])

export default __exports__